import { actionProps } from 'store/modules/types';
import { dataAddressProps, dataAddressTypes } from './types';

export function setUserAddress(data: dataAddressProps): actionProps {
  return {
    type: dataAddressTypes.SET_USER_ADDRESS,
    payload: {
      data,
    },
  };
}
